import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ActivatedRoute, Router } from '@angular/router'; 
import { OrderService } from '../_services/order.service';
import { ClientService } from 'app/_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef } from '@angular/core';
import { ChangeDetectionStrategy } from "@angular/core"; 
import flatpickr from "flatpickr";

@Component({
  //changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./orders.component.scss']
})
export class EditOrderComponent implements OnInit {
  contactUUID: string = "";
  orderId: number = 0;
  clientId: number = 0;
  clientInfo: any = [];
  contractInfo: any = [];
  orderInfo: any = {};
  orderInfoTemplate: any = {};
  orderItemsList: any = [];
  orderItemsForm: FormGroup = new FormGroup({});
  orderItemRowIds: string[] = [];
  contactTypeList: any = [];
//other order details
  order_updated_date: string = "";
//order items totals
  orderInfoTotals: any = [];
  update_message: string = "";
  deliveryList: any = [];
  template_name: string = "template1";
  loading: boolean = true;

  editOrderForm: FormGroup = new FormGroup({
    //order related
    order_created_date: new FormControl(""),
    order_note: new FormControl(""),
    delivery: new FormControl(""),
  })

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private tokenStorage: TokenStorageService,
    private order: OrderService,
    private clients: ClientService,
    private cdref: ChangeDetectorRef, 
  ) { }


  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.orderId = this.activatedRoute.snapshot.params['orderid'];

   
    //console.log('template returned', this.orderItemsList );


    this.order.getOrder$(this.contactUUID, this.orderId).subscribe({
      next: (data: {}) => {
        this.orderInfo = data;
        //console.log(this.orderInfo);
        
        this.clientInfo = this.orderInfo['client'];
        this.contractInfo = this.orderInfo['submission'];
        this.orderItemsList = this.orderInfo['items'];
        this.syncOrderItemRowIds();
        //this.orderItemsList.reverse();
        this.contactTypeList = this.clientInfo.contacts;

        this.orderInfo.prov_rate = 0.09975;
        this.orderInfo.fed_rate = 0.05;
        console.log("order",  this.orderInfo);
        //console.log(this.invoiceInfo['jobs']);
        //console.log(this.invoiceJobsList.length);
        this.orderInfoTotals['orderitems-subtotal-count']  = 0;
        this.orderInfoTotals['orderitems-subtotal-received']  = 0;
        this.orderInfoTotals['orderitems-tps-total-count'] = 0;
        this.orderInfoTotals['orderitems-tps-total-received'] = 0;
        this.orderInfoTotals['orderitems-tvq-total-count'] = 0;
        this.orderInfoTotals['orderitems-tvq-total-received'] = 0;
        this.orderInfoTotals['orderitems-total-count'] = 0;
        this.orderInfoTotals['orderitems-total-received'] = 0;

        this.order_updated_date = new Date(this.orderInfo.updated).toLocaleDateString("en-us");
      
        /********* pre-fill order list ***********/

   
        if(this.orderItemsList.length==0) {

           this.callTemplate();

       /* 
          this.orderItemsList.push({ amount: 19.00, is_taxable: true, order_count: 0, order_received: 0, description: 'SECURPAN', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 101.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'SOPRAFIXE', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 102.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'VIS 1 5/8', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 187.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'ELASTOCOLE', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 130.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'SOPRAFLASH', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 72.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'FINITION GRISE', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 126.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'FINITION BLANCHE', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 65.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'DRAIN', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 30.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'EVENT', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 120.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'MAXIMUM', tax_federal: 0, tax_provincial: 0 , tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 0.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'BOÎTE MÉCANIQUE', tax_federal: 0, tax_provincial: 0 , tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 82.00, is_taxable: true, order_count: 0, order_received: 0,  description: '180 FLAM/FLAM', tax_federal: 0, tax_provincial: 0, tax_federal_received: 0, tax_provincial_received: 0 });
          this.orderItemsList.push({ amount: 40.00, is_taxable: true, order_count: 0, order_received: 0,  description: 'PLYW0OD', tax_federal: 0, tax_provincial: 0 , tax_federal_received: 0, tax_provincial_received: 0 });
    */
        } else {
          console.log('template array', this.orderItemsList);
          this.rebuildOrderItemsForm();
        }
         
        this.orderInfoTotals['orderitems-total-count'] = this.orderInfoTotals['orderitems-subtotal-count'] + this.orderInfoTotals['orderitems-tps-total-count'] + this.orderInfoTotals['orderitems-tvq-total-count'];
        this.orderInfoTotals['orderitems-total-received'] = this.orderInfoTotals['orderitems-subtotal-received'] +this.orderInfoTotals['orderitems-tps-total-received'] + this.orderInfoTotals['orderitems-tvq-total-received'];
      
        this.editOrderForm.setValue({
          order_created_date: new Date(this.orderInfo.created).toLocaleDateString("en-us"),
          order_note: this.orderInfo.note,
          delivery: this.orderInfo.truck_type_id,
        });

     
      
      },
      error: (err: any) => {
        console.log("Something went wrong fetching the order: ", err)
      }
    });


    this.order.getOrderListDelivery$(this.contactUUID)
      .subscribe((data: any) => {
        this.deliveryList = data;
        console.log(this.deliveryList);
    });

    flatpickr(".date", {
        altInput: false,
        altFormat: "F j, Y",
        ariaDateFormat: "Y-m-d",
        dateFormat: "Y-m-d"
    });
  }

  //triggered after the parent form loads
  /*
  ngAfterContentChecked() {
    //this.cdref.detectChanges();
    Promise.resolve().then(() => this.loading = false )
  }
  */

  
//form ready for dynamic filling
/*
  dynoFormReady(): boolean {
    console.log('this.orderItemsList.length', this.orderItemsList.length);

    

   
  }
*/

ngAfterViewInit(): void {
  this.setupRulesForm();
}

setupRulesForm(): void {
  for(let rule of this.orderItemsList) {
    this.orderItemsForm.addControl(rule.name, new FormControl(''));
  }
}

private syncOrderItemRowIds(): void {
  const currentRows = Array.isArray(this.orderItemsList) ? this.orderItemsList : [];
  const existingRowIds = Array.isArray(this.orderItemRowIds) ? this.orderItemRowIds : [];
  const nextIds: string[] = [];

  currentRows.forEach((_: any, index: number) => {
    nextIds.push(existingRowIds[index] || this.generateRowId());
  });

  this.orderItemRowIds = nextIds;
}

private generateRowId(): string {
  return `row-${Math.random().toString(36).slice(2, 10)}`;
}

public getOrderItemControlName(index: number, field: string): string {
  const rowId = (this.orderItemRowIds ?? [])[index] || `row-${index}`;
  return `${field}_${rowId}`;
}

public normalizeOrderItemsPayload(orderValues: any): any {
  const normalized: any = {};

  if (!orderValues) {
    return normalized;
  }

  this.orderItemsList.forEach((_: any, index: number) => {
    const fieldPrefixes = [
      'orderitem_amount',
      'orderitem_istaxable',
      'orderitem_order-count',
      'orderitem_order-received',
      'orderitem_description',
      'orderitem_total-count',
      'orderitem_total-received',
    ];

    fieldPrefixes.forEach((fieldPrefix: string) => {
      const stableControlName = this.getOrderItemControlName(index, fieldPrefix);
      const legacyControlName = `${fieldPrefix}_${index}`;
      normalized[legacyControlName] = orderValues[stableControlName];
    });
  });

  return normalized;
}

trackByOrderItem = (index: number, item: any): string | number => {
  const rowIds = this.orderItemRowIds ?? [];
  return rowIds[index] || item?.id || index;
}

private rebuildOrderItemsForm(): void {
  this.syncOrderItemRowIds();
  this.refreshOrderTotals();

  for (let i = 0; i < this.orderItemsList.length; i++) {
    const item = this.orderItemsList[i];

    const amountControlName = this.getOrderItemControlName(i, 'orderitem_amount');
    const taxableControlName = this.getOrderItemControlName(i, 'orderitem_istaxable');
    const qtyOrderControlName = this.getOrderItemControlName(i, 'orderitem_order-count');
    const qtyReceivedControlName = this.getOrderItemControlName(i, 'orderitem_order-received');
    const descriptionControlName = this.getOrderItemControlName(i, 'orderitem_description');
    const totalCountControlName = this.getOrderItemControlName(i, 'orderitem_total-count');
    const totalReceivedControlName = this.getOrderItemControlName(i, 'orderitem_total-received');

    if (!this.orderItemsForm.contains(amountControlName)) {
      this.orderItemsForm.addControl(amountControlName, new FormControl(''));
    }
    this.orderItemsForm.get(amountControlName)?.patchValue(Number(item.amount), { emitEvent: false });

    if (!this.orderItemsForm.contains(taxableControlName)) {
      this.orderItemsForm.addControl(taxableControlName, new FormControl(''));
    }
    this.orderItemsForm.get(taxableControlName)?.patchValue(item.is_taxable, { emitEvent: false });

    if (!this.orderItemsForm.contains(qtyOrderControlName)) {
      this.orderItemsForm.addControl(qtyOrderControlName, new FormControl(''));
    }
    this.orderItemsForm.get(qtyOrderControlName)?.patchValue(item.order_count, { emitEvent: false });

    if (!this.orderItemsForm.contains(qtyReceivedControlName)) {
      this.orderItemsForm.addControl(qtyReceivedControlName, new FormControl(''));
    }
    this.orderItemsForm.get(qtyReceivedControlName)?.patchValue(item.order_received, { emitEvent: false });

    if (!this.orderItemsForm.contains(descriptionControlName)) {
      this.orderItemsForm.addControl(descriptionControlName, new FormControl(''));
    }
    this.orderItemsForm.get(descriptionControlName)?.patchValue(item.description, { emitEvent: false });

    if (!this.orderItemsForm.contains(totalCountControlName)) {
      this.orderItemsForm.addControl(totalCountControlName, new FormControl(''));
    }
    this.orderItemsForm.get(totalCountControlName)?.patchValue(Number(item.amount * item.order_count), { emitEvent: false });

    if (!this.orderItemsForm.contains(totalReceivedControlName)) {
      this.orderItemsForm.addControl(totalReceivedControlName, new FormControl(''));
    }
    this.orderItemsForm.get(totalReceivedControlName)?.patchValue(Number(item.amount * item.order_received), { emitEvent: false });
  }
}

private refreshOrderTotals(): void {
  if (!this.orderInfoTotals || Array.isArray(this.orderInfoTotals)) {
    this.orderInfoTotals = {};
  }

  this.orderInfoTotals['orderitems-subtotal-count'] = 0;
  this.orderInfoTotals['orderitems-subtotal-received'] = 0;
  this.orderInfoTotals['orderitems-tps-total-count'] = 0;
  this.orderInfoTotals['orderitems-tps-total-received'] = 0;
  this.orderInfoTotals['orderitems-tvq-total-count'] = 0;
  this.orderInfoTotals['orderitems-tvq-total-received'] = 0;
  this.orderInfoTotals['orderitems-total-count'] = 0;
  this.orderInfoTotals['orderitems-total-received'] = 0;

  for (let i = 0; i < this.orderItemsList.length; i++) {
    const item = this.orderItemsList[i];
    const totalCountControlName = this.getOrderItemControlName(i, 'orderitem_total-count');
    const totalReceivedControlName = this.getOrderItemControlName(i, 'orderitem_total-received');
    const rowSubTotalCount = Number(item.amount * item.order_count);
    const rowSubTotalReceived = Number(item.amount * item.order_received);
    const rowTaxFederal = Number(item.tax_federal ?? 0);
    const rowTaxProvincial = Number(item.tax_provincial ?? 0);
    const rowTaxFederalReceived = Number(item.tax_federal_received ?? 0);
    const rowTaxProvincialReceived = Number(item.tax_provincial_received ?? 0);

    this.orderInfoTotals[totalCountControlName] = rowSubTotalCount;
    this.orderInfoTotals[totalReceivedControlName] = rowSubTotalReceived;

    this.orderInfoTotals['orderitems-subtotal-count'] += rowSubTotalCount;
    this.orderInfoTotals['orderitems-subtotal-received'] += rowSubTotalReceived;
    this.orderInfoTotals['orderitems-tps-total-count'] += rowTaxFederal;
    this.orderInfoTotals['orderitems-tps-total-received'] += rowTaxFederalReceived;
    this.orderInfoTotals['orderitems-tvq-total-count'] += rowTaxProvincial;
    this.orderInfoTotals['orderitems-tvq-total-received'] += rowTaxProvincialReceived;
  }

  this.orderInfoTotals['orderitems-total-count'] = this.orderInfoTotals['orderitems-subtotal-count'] + this.orderInfoTotals['orderitems-tps-total-count'] + this.orderInfoTotals['orderitems-tvq-total-count'];
  this.orderInfoTotals['orderitems-total-received'] = this.orderInfoTotals['orderitems-subtotal-received'] + this.orderInfoTotals['orderitems-tps-total-received'] + this.orderInfoTotals['orderitems-tvq-total-received'];
  this.cdref.markForCheck();
  Promise.resolve().then(() => this.cdref.detectChanges());
}

private removeOrderItemControls(rowId: string): void {
  const fieldPrefixes = [
    'orderitem_amount',
    'orderitem_istaxable',
    'orderitem_order-count',
    'orderitem_order-received',
    'orderitem_description',
    'orderitem_total-count',
    'orderitem_total-received',
  ];

  fieldPrefixes.forEach((fieldPrefix: string) => {
    const controlName = `${fieldPrefix}_${rowId}`;
    if (this.orderItemsForm.contains(controlName)) {
      this.orderItemsForm.removeControl(controlName);
    }
  });
}

renderForm(): boolean {
  return Array.isArray(this.orderItemsList);
}

callTemplate(): void {


  this.order.getOrdertemplate$(this.contactUUID, this.template_name ).subscribe({
    next: (data: {}) => {
      this.orderInfoTemplate = data;
   
      console.log('template loaded', this.orderInfoTemplate);

    
        //initialize new order from template
        for(let j=0; j < this.orderInfoTemplate.length; j++) {

          this.orderItemsList.push({ 
            amount: this.orderInfoTemplate[j]['amount'], 
            is_taxable: this.orderInfoTemplate[j]['is_taxable'], 
            order_count: this.orderInfoTemplate[j]['order_count'], 
            order_received: 0, 
            description: this.orderInfoTemplate[j]['description'],  
            tax_federal: 0, 
            tax_provincial: 0, 
            tax_federal_received: 0, 
            tax_provincial_received: 0 
          });
          this.orderItemRowIds.push(this.generateRowId());
        // console.log('item', i);
        }



        this.rebuildOrderItemsForm();
    
   

      console.log('template array', this.orderItemsList);
      return;

    },
    error: (err: any) => {
      console.log("Something went wrong fetching the  order template: ", err)
    }

    
  });


}

trackByCreated(index:any, item:any) { 
  console.log('the item', item, 'the index', index);
  return item.created; 
}

  openCalendar(e: any): void {
    console.log(e)
  }

  getClient(client: number): void {
    this.clients.getClient$(this.contactUUID, client).subscribe({
      next: data => {
        this.clientInfo = data;
      },
      error: err => {
        console.log("Something went wrong fetching the client: ", err)
      }
    });
  }

  /*  Add an extra empty email field */
  addOrderItem(): void  {
    this.orderItemsList.push({
        amount: 0,
        is_taxable: true,
        order_count: 0,
        order_received: 0,
        description: '',
        tax_federal: 0,
        tax_provincial: 0,
        tax_federal_received: 0,
        tax_provincial_received: 0,
    });
    this.orderItemRowIds.push(this.generateRowId());
    this.rebuildOrderItemsForm();
    this.cdref.detectChanges();
  }

  onChangeOrderItemDescription(index: number, fieldValue: any): void {
    this.orderItemsList[index].description = fieldValue.value || '';
  }

  onChangeOrderItemAmount( index:number, fieldValue: any):void {

    let old_amount =  Number(this.orderItemsList[index].amount);
    let old_tax_federal =   Number(this.orderItemsList[index].tax_federal);
    let old_tax_federal_rec =   Number(this.orderItemsList[index].tax_federal_received);
    let old_tax_provincial =   Number(this.orderItemsList[index].tax_provincial);
    let old_tax_provincial_rec =   Number(this.orderItemsList[index].tax_provincial_received);
    if(isNaN(fieldValue.value)){
      this.orderItemsList[index].amount = 0;
    }else{
     this.orderItemsList[index].amount =  Number(fieldValue.value);
    }
    this.orderItemsList[index].tax_federal =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_count * this.orderInfo.fed_rate);
    this.orderItemsList[index].tax_provincial =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_count * this.orderInfo.prov_rate);
    this.orderItemsList[index].tax_federal_received =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received * this.orderInfo.fed_rate);
    this.orderItemsList[index].tax_provincial_received =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received * this.orderInfo.prov_rate);

    this.orderInfoTotals[this.getOrderItemControlName(index, 'orderitem_total-count')] = Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_count);
    this.orderInfoTotals[this.getOrderItemControlName(index, 'orderitem_total-received')] = Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received);
    this.orderInfoTotals['orderitems-subtotal-count'] = Number(this.orderInfoTotals['orderitems-subtotal-count']) -  Number(old_amount*this.orderItemsList[index].order_count) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count);
    this.orderInfoTotals['orderitems-subtotal-received'] = Number(this.orderInfoTotals['orderitems-subtotal-received']) -  Number(old_amount*this.orderItemsList[index].order_received) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received);
    this.orderInfoTotals['orderitems-tps-total-count'] = Number(this.orderInfoTotals['orderitems-tps-total-count']) -  Number(old_tax_federal) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count *this.orderInfo.fed_rate);
    this.orderInfoTotals['orderitems-tps-total-received'] = Number(this.orderInfoTotals['orderitems-tps-total-received']) -  Number(old_tax_federal_rec) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received *this.orderInfo.fed_rate);
    this.orderInfoTotals['orderitems-tvq-total-count'] = Number(this.orderInfoTotals['orderitems-tvq-total-count']) -  Number(old_tax_provincial)+ Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count *this.orderInfo.prov_rate);
    this.orderInfoTotals['orderitems-tvq-total-received'] = Number(this.orderInfoTotals['orderitems-tvq-total-received']) -  Number(old_tax_provincial_rec)+ Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received *this.orderInfo.prov_rate);
    this.orderInfoTotals['orderitems-total-count'] = Number(this.orderInfoTotals['orderitems-subtotal-count']) + Number(this.orderInfoTotals['orderitems-tps-total-count']) + Number(this.orderInfoTotals['orderitems-tvq-total-count']);
    this.orderInfoTotals['orderitems-total-received'] = Number(this.orderInfoTotals['orderitems-subtotal-received']) + Number(this.orderInfoTotals['orderitems-tps-total-received']) + Number(this.orderInfoTotals['orderitems-tvq-total-received']);

    console.log('index',index);
    console.log('subtot', this.orderInfoTotals['orderitems-subtotal-count']);
    console.log('tps', this.orderInfoTotals['orderitems-tps-total-count']);
    console.log('tvq', this.orderInfoTotals['orderitems-tvq-total-count']);
    console.log('total', this.orderInfoTotals['orderitems-total-count']);
    console.log('change job from', old_amount);
    console.log('to job new from', fieldValue.value);
  }

  onChangeOrderItemQtyOrder( index:number, fieldValue: any):void {

    let old_order_count =  Number(this.orderItemsList[index].order_count);
    let old_tax_federal =   Number(this.orderItemsList[index].tax_federal);
    let old_tax_provincial =   Number(this.orderItemsList[index].tax_provincial);
    if(isNaN(fieldValue.value)){
      this.orderItemsList[index].order_count = 0;
    }else{
     this.orderItemsList[index].order_count =  Number(fieldValue.value);
    }
    this.orderItemsList[index].tax_federal =  Number(this.orderItemsList[index].amount)* Number(this.orderItemsList[index].order_count) * Number(this.orderInfo.fed_rate);
    this.orderItemsList[index].tax_provincial =  Number(this.orderItemsList[index].amount) * Number(this.orderItemsList[index].order_count) * Number(this.orderInfo.prov_rate);
   
    this.orderInfoTotals[this.getOrderItemControlName(index, 'orderitem_total-count')] = Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_count);
    this.orderInfoTotals['orderitems-subtotal-count'] = Number(this.orderInfoTotals['orderitems-subtotal-count']) -  Number(old_order_count *this.orderItemsList[index].amount) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count);
    this.orderInfoTotals['orderitems-tps-total-count'] = Number(this.orderInfoTotals['orderitems-tps-total-count']) -  Number(old_tax_federal) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count *this.orderInfo.fed_rate);
    this.orderInfoTotals['orderitems-tvq-total-count'] = Number(this.orderInfoTotals['orderitems-tvq-total-count']) -  Number(old_tax_provincial)+ Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_count *this.orderInfo.prov_rate);
    this.orderInfoTotals['orderitems-total-count'] = Number(this.orderInfoTotals['orderitems-subtotal-count']) + Number(this.orderInfoTotals['orderitems-tps-total-count']) + Number(this.orderInfoTotals['orderitems-tvq-total-count']);
   
    console.log('index',index);
    console.log('subtot', this.orderInfoTotals['orderitems-subtotal-count']);
    console.log('tps', this.orderInfoTotals['orderitems-tps-total-count']);
    console.log('tvq', this.orderInfoTotals['orderitems-tvq-total-count']);
    console.log('total', this.orderInfoTotals['orderitems-total-count']);
    console.log('change job from', old_order_count);
    console.log('to job new from', fieldValue.value);
  }

  onChangeOrderItemQtyOrderRec( index:number, fieldValue: any):void {

    let old_order_received =  Number(this.orderItemsList[index].order_received);
    let old_tax_federal_rec =   Number(this.orderItemsList[index].tax_federal_received);
    let old_tax_provincial_rec =   Number(this.orderItemsList[index].tax_provincial_received);
    if(isNaN(fieldValue.value)){
      this.orderItemsList[index].order_received = 0;
    }else{
     this.orderItemsList[index].order_received =  Number(fieldValue.value);
    }
    this.orderItemsList[index].tax_federal_received =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received * this.orderInfo.fed_rate);
    this.orderItemsList[index].tax_provincial_received =  Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received * this.orderInfo.prov_rate);

    this.orderInfoTotals[this.getOrderItemControlName(index, 'orderitem_total-received')] = Number(this.orderItemsList[index].amount * this.orderItemsList[index].order_received);  
    this.orderInfoTotals['orderitems-subtotal-received'] = Number(this.orderInfoTotals['orderitems-subtotal-received']) -  Number(this.orderItemsList[index].amount*old_order_received) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received);
    this.orderInfoTotals['orderitems-tps-total-received'] = Number(this.orderInfoTotals['orderitems-tps-total-received']) -  Number(old_tax_federal_rec) + Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received *this.orderInfo.fed_rate);
    this.orderInfoTotals['orderitems-tvq-total-received'] = Number(this.orderInfoTotals['orderitems-tvq-total-received']) -  Number(old_tax_provincial_rec)+ Number(this.orderItemsList[index].amount*this.orderItemsList[index].order_received*this.orderInfo.prov_rate);
    this.orderInfoTotals['orderitems-total-received'] = Number(this.orderInfoTotals['orderitems-subtotal-received']) + Number(this.orderInfoTotals['orderitems-tps-total-received']) + Number(this.orderInfoTotals['orderitems-tvq-total-received']);

    console.log('index',index);
    console.log('subtot', this.orderInfoTotals['orderitems-subtotal-count']);
    console.log('tps', this.orderInfoTotals['orderitems-tps-total-count']);
    console.log('tvq', this.orderInfoTotals['orderitems-tvq-total-count']);
    console.log('total', this.orderInfoTotals['orderitems-total-count']);
    console.log('change job from', old_order_received);
    console.log('to job new from', fieldValue.value);
  }

  onChangeOrderItemTax( index:number, event: any):void {
    this.orderItemsList[index].is_taxable = !event.target.checked;
    let old_tax_federal =   Number(this.orderItemsList[index].tax_federal);
    let old_tax_provincial =   Number(this.orderItemsList[index].tax_provincial);
    let old_tax_federal_received =   Number(this.orderItemsList[index].tax_federal_received);
    let old_tax_provincial_received =   Number(this.orderItemsList[index].tax_provincial_received);

    console.log(' tax is ',this.orderItemsList[index].is_taxable);

    if(event.target.checked == false) {
      this.orderItemsList[index].tax_federal = Number(0);
      this.orderItemsList[index].tax_provincial = Number(0);
      this.orderItemsList[index].tax_federal_received = Number(0);
      this.orderItemsList[index].tax_provincial_received = Number(0);
      old_tax_federal = -old_tax_federal ;
      old_tax_provincial = -old_tax_provincial; 
      old_tax_federal_received = -old_tax_federal_received; 
      old_tax_provincial_received = -old_tax_provincial_received; 
    }else{
      this.orderItemsList[index].tax_federal =  Number(this.orderItemsList[index].amount) * Number(this.orderItemsList[index].order_count) * Number(this.orderInfo.fed_rate);
      this.orderItemsList[index].tax_provincial =  Number(this.orderItemsList[index].amount) * Number(this.orderItemsList[index].order_count) * Number(this.orderInfo.prov_rate);
      this.orderItemsList[index].tax_federal_received =  Number(this.orderItemsList[index].amount) * Number(this.orderItemsList[index].order_received)  * Number(this.orderInfo.fed_rate);
      this.orderItemsList[index].tax_provincial_received =  Number(this.orderItemsList[index].amount) * Number(this.orderItemsList[index].order_received) * Number(this.orderInfo.prov_rate);
    }
    console.log(' =============================== ');
    console.log(' old fed tax ',old_tax_federal );
    console.log(' new fed tax ',this.orderItemsList[index].tax_federal );
    console.log(' old prov tax ',old_tax_provincial );
    console.log(' new prov tax ',this.orderItemsList[index].tax_provincial );

    
    this.orderInfoTotals['orderitems-tps-total-count'] = Number(this.orderInfoTotals['orderitems-tps-total-count'] + this.orderItemsList[index].tax_federal + old_tax_federal );
    this.orderInfoTotals['orderitems-tvq-total-count'] = Number(this.orderInfoTotals['orderitems-tvq-total-count'] + this.orderItemsList[index].tax_provincial +old_tax_provincial ) ;
    this.orderInfoTotals['orderitems-total-count'] = Number(this.orderInfoTotals['orderitems-subtotal-count']) + Number(this.orderInfoTotals['orderitems-tps-total-count']) + Number(this.orderInfoTotals['orderitems-tvq-total-count']);
    this.orderInfoTotals['orderitems-tps-total-received'] = Number(this.orderInfoTotals['orderitems-tps-total-received'] + this.orderItemsList[index].tax_federal_received + old_tax_federal_received );
    this.orderInfoTotals['orderitems-tvq-total-received'] = Number(this.orderInfoTotals['orderitems-tvq-total-received'] + this.orderItemsList[index].tax_provincial_received +old_tax_provincial_received ) ;
    this.orderInfoTotals['orderitems-total-received'] = Number(this.orderInfoTotals['orderitems-subtotal-received']) + Number(this.orderInfoTotals['orderitems-tps-total-received']) + Number(this.orderInfoTotals['orderitems-tvq-total-received']);
    
    console.log(' tps ',this.orderInfoTotals['orderitems-tps-total-count']);
    console.log(' tvq ',this.orderInfoTotals['orderitems-tvq-total-count']);
  }
/*
  onChangeInvoicePayAmount( index:number, fieldValue: any):void {
    let old_payment = Number(this.invoicePaymentsList[index].amount);
    //remove decimal comma formatting from number
    //this.invoicePaymentsList[index].amount = fieldValue.value.replace(/[^\d.-]/g, '');
    this.invoicePaymentsList[index].amount = Number(fieldValue.value);
    console.log(this.invoicePaymentsList[index].amount );

    this.orderInfoTotals['invoiceitems_total_paiements'] =  Number(this.orderInfoTotals['invoiceitems_total_paiements']) - Number(old_payment) + Number(this.invoicePaymentsList[index].amount);
    this.orderInfoTotals['invoiceitems_total_restant'] =  Number(this.orderInfoTotals['invoiceitems_total_count']) -  Number(this.orderInfoTotals['invoiceitems_total_paiements']);
    
    console.log('is it a number?', isNaN(Number(fieldValue.value)));
    console.log('pay old', old_payment);
    console.log('to pay new', this.invoicePaymentsList[index].amount);
  }
*/

  removeOrderItem(uId: number): void  {
    if (!this.orderItemsList[uId]) {
      return;
    }

    console.log('uid',uId);
    console.log('removing job',this.orderItemsList[uId]);

    const removedRowId = this.orderItemRowIds[uId];
    this.removeOrderItemControls(removedRowId);
    this.orderItemsList.splice(uId, 1);
    this.orderItemRowIds.splice(uId, 1);
    this.rebuildOrderItemsForm();
    this.cdref.detectChanges();

    console.log('sub-count', this.orderInfoTotals['orderitems-tps-total-count']);
    //call remove client info here
  }

  goToTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  onSubmit(formValues: any, orderValues: any,): void {

    console.log("All values ", formValues)

    this.order.getOrder$(this.contactUUID, this.orderId).subscribe((data: {}) => {
      this.orderInfo = data;
    })

    const normalizedItems = this.normalizeOrderItemsPayload(orderValues);

    let orderInfos: any = {
      "order_id": this.orderInfo.order_id, 
      "note": formValues.order_note,
      "truck_type_id": Number(formValues.delivery),
      "updated": this.orderInfo.updated,
      "rebate": 0,
      "items": normalizedItems,
      "order_no": this.orderInfo.order_no, 
    }

    //this.submitOrderInfos(orderInfos);

    this.order.modifyOrder$(this.contactUUID, this.orderId, orderInfos).subscribe({
      next: (data:any) => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the order",data);
        this.orderInfo.updated = data.updated;
        this.goToTop();
      },
      error: (err: any) => {
        console.log("Something went wrong updating the order: ", err)
        console.log("oops", orderInfos);
      }
    })
  }

  orderPrint(order: number): void {
    this.order.exportOrderPrint$(this.contactUUID, order).subscribe({
      next: data => {
        console.log("Success printing the order: ", data)

        let printContents, popupWin: any;
        printContents = document.getElementById('print-section')!.innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(data.order);
        setTimeout(function() {
          popupWin.document.close();
          popupWin.window.print();
        }, 250);
      },
      error: err => {
        console.log("Something went wrong while printing the order: ", err.error.errors)
      }
    });
  }

}
